import { all, takeEvery, fork, call, put } from 'redux-saga/effects';
import axios from 'axios';
import isFunction from 'lodash/isFunction';

import actions from './actions';
import { handleError } from '../../errorHandler';
import { API_HOST } from '../../constants';

const LOGISTIC_API_URL = `${API_HOST}/api/logistic`;

function* searchlogisticCalculativeMethodsOfVehicle() {
  yield takeEvery(actions.SEARCH_LOGISTIC_CALCULATIVE_METHODS_OF_VEHICLE, function* (action) {
    const { parameters, onSuccess } = action;
    try {
      const res = yield call(
        [axios, 'get'],
        `${LOGISTIC_API_URL}/methodsOfVehicle?${parameters.toString()}`,
      );
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (err) {
      yield handleError(err);
    } finally {
      yield put({ type: actions.SEARCH_LOGISTIC_CALCULATIVE_METHODS_OF_VEHICLE_ENDED });
    }
  });
}

function* searchLogisticTools() {
  yield takeEvery(actions.SEARCH_LOGISTIC_TOOLS, function* (action) {
    const { parameters, onSuccess } = action;
    try {
      const res = yield call([axios, 'get'], `${LOGISTIC_API_URL}/tool?${parameters.toString()}`);
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (err) {
      yield handleError(err);
    } finally {
      yield put({ type: actions.SEARCH_LOGISTIC_TOOLS_ENDED });
    }
  });
}

function* searchLogisticOrders() {
  yield takeEvery(actions.SEARCH_LOGISTIC_ORDERS, function* (action) {
    const { parameters, onSuccess } = action;
    try {
      const res = yield call([axios, 'get'], `${LOGISTIC_API_URL}/order?${parameters.toString()}`);
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (err) {
      yield handleError(err);
    } finally {
      yield put({ type: actions.SEARCH_LOGISTIC_ORDERS_ENDED });
    }
  });
}

function* searchLogisticOrderRecords() {
  yield takeEvery(actions.SEARCH_LOGISTIC_ORDER_RECORDS, function* (action) {
    const { parameters, onSuccess } = action;
    try {
      const res = yield call(
        [axios, 'get'],
        `${LOGISTIC_API_URL}/order/records?${parameters.toString()}`,
      );
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (err) {
      yield handleError(err);
    } finally {
      yield put({ type: actions.SEARCH_LOGISTIC_ORDER_RECORDS_ENDED });
    }
  });
}

function* createLogisticTool() {
  yield takeEvery(actions.CREATE_LOGISTIC_TOOL, function* (action) {
    const { formData, onSuccess } = action;
    try {
      const res = yield call([axios, 'post'], `${LOGISTIC_API_URL}/tool`, formData);
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (err) {
      yield handleError(err);
    } finally {
      yield put({ type: actions.CREATE_LOGISTIC_TOOL_ENDED });
    }
  });
}

function* updateLogisticTool() {
  yield takeEvery(actions.UPDATE_LOGISTIC_TOOL, function* (action) {
    const { formData, onSuccess } = action;
    try {
      const res = yield call([axios, 'put'], `${LOGISTIC_API_URL}/tool`, formData);
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (err) {
      yield handleError(err);
    } finally {
      yield put({ type: actions.UPDATE_LOGISTIC_TOOL_ENDED });
    }
  });
}

export default function* rootSaga() {
  yield all([
    fork(searchLogisticTools),
    fork(createLogisticTool),
    fork(updateLogisticTool),
    fork(searchlogisticCalculativeMethodsOfVehicle),
    fork(searchLogisticOrders),
    fork(searchLogisticOrderRecords),
  ]);
}
